export function loadClassicScript(src: string): Promise<void> {
  const existing = document.querySelector<HTMLScriptElement>(`script[data-qc-runtime="${CSS.escape(src)}"]`);
  if (existing?.dataset.loaded === 'true') return Promise.resolve();

  return new Promise((resolve, reject) => {
    const script = existing ?? document.createElement('script');
    script.src = src;
    script.async = false;
    script.dataset.qcRuntime = src;
    script.addEventListener('load', () => {
      script.dataset.loaded = 'true';
      resolve();
    }, { once: true });
    script.addEventListener('error', () => reject(new Error(`Could not load ${src}`)), { once: true });
    if (!existing) document.body.appendChild(script);
  });
}
